import { res } from 'components/Image'
import { LayoutState } from 'components/Layout'
import { currency } from 'lib/currency'
import { isEligibleForGift, type Cart } from 'lib/hooks/use-cart'
import { Link, Title } from '../Cart'
import i from 'i18next'
import Trash from 'components/svg/Trash'

type Props = {
	item: Cart['lineItems'][0]
	update: LayoutState['update']
}

export const Item: React.FC<Props> = ({ item, update }) => (
	<Link key={item.id} product={item} className="item">
		<picture>
			<img
				className="product"
				src={res( item.variant.image?.originalSrc, '152x' )}
			/>
		</picture>
		<div>
			<Title item={item} />
			<div style={{ display: 'flex', gap: 16 }} onClick={( e ) => e.preventDefault()}>
				<div className="buttons">
					<button onClick={() => update( item.id, item.quantity - 1 )}>-</button>
					<div className="quantity">{item.quantity}</div>
					<button onClick={() => update( item.id, item.quantity + 1 )}>+</button>
				</div>
				<button
					className="button-delete"
					onClick={() => update( item.id, 0 )}
				>
					<Trash />
				</button>
			</div>
		</div>
		<div
			style={{
				justifyContent: 'flex-start',
				alignItems: 'flex-end',
				textAlign: 'right',
			}}
		>
			{item.variant.compareAtPrice && (
				<h3 className="discount">
					{currency.format( item.variant.compareAtPrice.amount )}
				</h3>
			)}
			<h3 className="price">{currency.format( item.variant.priceV2.amount )}</h3>
		</div>
		{!isEligibleForGift( item ) && (
			<div className="info">{i.t( 'cart.gift.excluded' )}</div>
		)}
	</Link>
)
